import React from "react";
import { message, Form } from "antd";
import styled from "styled-components";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

import Button from "components/buttons/Button";
import Input from "components/inputs/Input";

export default function Specs({ form, initialValue }) {
  const [titleValue, setTitleValue] = React.useState(null);
  const [textValue, setTextValue] = React.useState(null);
  const [list, setList] = React.useState(
    initialValue?.length && typeof initialValue === "object" ? initialValue : []
  );
  console.log("spec, ", initialValue, list, list.length, 1);
  const handleTitleInput = ({ target }) => {
    setTitleValue(target.value);
  };
  const handleTextInput = ({ target }) => {
    setTextValue(target.value);
  };
  const handleAdd = () => {
    if (!textValue) {
      message.error("لطفا مقدار ویژگی را تایپ کنید.");
      return false;
    }
    if (!titleValue) {
      message.error("لطفا عنوان ویژگی را تایپ کنید.");
      return false;
    }
    setList((e) => [
      ...e,
      {
        title: titleValue,
        value: textValue,
      },
    ]);
    setTitleValue(null);
    setTextValue(null);
    return false;
  };
  const handleEdit = ({ target }) => {
    let index = Number(target.dataset.index);
    let type = target.dataset.type;
    if (!target.innerText) {
      target.innerText = list[index][type];
      message.error("بازیابی شد.");
      return false;
    }
    if (target.innerText !== list[index][type]) {
      setList((list) => {
        let temp = [...list];
        temp[index][type] = target.innerText;
        return temp;
      });
      message.success("با موفقیت آپدیت شد.");
    }
    return;
  };
  const handleDelete = (key) => {
    setList((e) => {
      let newList = [...e];
      newList.splice(key, 1);
      console.log(key, newList);
      return newList;
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleAdd();
    }
  };

  React.useEffect(() => {
    form.setFieldsValue({ specs: list });
  }, [list]);
  return (
    <>
      <Container>
        <Form.Item name="specs">
          <h3>مشخصات :</h3>
        </Form.Item>
        {list?.length
          ? list?.map((item, key) => (
              <div className="item" key={key}>
                <span
                  data-index={key}
                  data-type="title"
                  contentEditable="true"
                  className="notranslate"
                  translate="no"
                  onBlur={handleEdit}
                  suppressContentEditableWarning={true}
                >
                  {item.title}
                </span>{" "}
                <span
                  data-index={key}
                  data-type="value"
                  contentEditable="true"
                  className="notranslate"
                  translate="no"
                  onBlur={handleEdit}
                  suppressContentEditableWarning={true}
                >
                  {item.value}{" "}
                </span>{" "}
                <DeleteOutlined
                  className="delete"
                  onClick={() => handleDelete(key)}
                />
              </div>
            ))
          : null}
        <InputContainer>
          <Input
            placeholder="عنوان"
            value={titleValue}
            onChange={handleTitleInput}
            onKeyDown={handleKeyDown}
          />
          <Input
            placeholder="مقدار"
            value={textValue}
            onChange={handleTextInput}
            onKeyDown={handleKeyDown}
          />
          <Button type="button" size="middle" onClick={handleAdd}>
            <PlusOutlined />
            اضافه کردن{" "}
          </Button>
        </InputContainer>
      </Container>
    </>
  );
}

const Container = styled.div`
  margin-top: 3rem;
  text-align: start;

  & .item {
    padding: 7px;
    border-radius: 4px;
    margin-bottom: 8px;
    border: 1px dashed #d5d5d5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > span:first-child {
      border-left: 1px solid #d5d5d5;
    }
    > span {
      width: calc(50% - 18px);
      display: inline-flex;
      padding-right: 8px;
    }

    & .delete {
      color: red;
      margin-right: auto;
      font-size: 18px;
      cursor: pointer;
      padding: 2px 8px;
      width: 36px;
    }
  }
  & .ant-form-item {
    margin-bottom: 4px;
  }
`;
const InputContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  & > div {
    width: 49%;
    height: 38px;
    margin-top: 0;
    input {
      height: 38px;
    }
  }
  button {
    width: 100%;
    height: 38px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;
